export const svgIconHostLvbetlv: string = 'https://lvbet.lv';
